var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00224 1.99872C3.55577 1.99872 4.00449 2.44643 4.00449 2.99872V20.0013H20.9978C21.5513 20.0013 22 20.449 22 21.0013C22 21.5536 21.5513 22.0013 20.9978 22.0013H3.15258C2.51603 22.0013 2 21.4864 2 20.8513V2.99872C2 2.44643 2.44872 1.99872 3.00224 1.99872Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12446 17.1792C6.12446 17.5935 6.46024 17.9292 6.87445 17.9292L19.8813 17.9292C20.4142 17.9292 20.7771 17.389 20.5757 16.8957L17.7657 10.909C17.5696 10.4287 16.9567 10.2878 16.5705 10.6343L14.0861 12.5442C13.7781 12.8206 13.3043 12.7952 13.0275 12.4875L7.43215 7.00724C6.97244 6.496 6.12446 6.82119 6.12446 7.50872L6.12446 17.1792Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartArea);
export default __webpack_public_path__ + "static/media/chart_area.f7629e827a416ef06683f4ca2dc50717.svg";
export { ForwardRef as ReactComponent };